import PropertyListShow from "../../components/Property/PropertyListShow";
import { Outlet, useNavigate, useOutletContext } from "react-router-dom";
import ContentLayout from "../../components/UI/Layout/ContentLayout.tsx";
import HeaderLayout from "../../components/UI/Layout/HeaderLayout.tsx";
import VideoTutorialsButton from "../../components/VideoTutorials/VideoTutorialsButton";
// @ts-expect-error pure js
import useProperties from "../../hooks/use-properties";
import type { Property } from "../../models/property";
import type { Profile } from "../../components/Profile/types";

export const ROOT_PATH = "/bailleur/properties/";

interface OutletContext {
  profiles: Profile[];
}

interface UsePropertiesResult {
  properties: Property[];
  duplicateProperty: (property: Property) => Promise<void>;
  isLoading: boolean;
}

function PropertyListPage() {
  const { profiles } = useOutletContext<OutletContext>();
  const nav = useNavigate();
  const { properties, duplicateProperty, isLoading } =
    useProperties() as UsePropertiesResult;

  return (
    <>
      <ContentLayout
        header={
          <HeaderLayout
            title="Biens"
            breadcrumb={[
              { label: "Tableau de bord", to: "/bailleur" },
              { label: "Biens" },
            ]}
            actions={<VideoTutorialsButton page="biens" />}
          />
        }
        body={
          <PropertyListShow
            properties={properties}
            onDuplicateProperty={duplicateProperty}
            onAdd={() => nav("add")}
            isLoading={isLoading}
          />
        }
      />
      <Outlet
        context={{
          profiles: profiles,
        }}
      />
    </>
  );
}

export default PropertyListPage;
